<div class="callback-wrapper">
  <h1 class="settings-title">Zoom Account Setup</h1>

  <edu-card class="settings-card">
    <div *ngIf="isLoading" class="callback-content">
      <div class="spinner"></div>
      <h2 edu-card-title>Linking your Zoom account...</h2>
      <p class="integration-description">
        Please wait while we complete the setup.
      </p>
    </div>

    <div *ngIf="successMessage && !isLoading" class="callback-content">
      <div class="success-icon">✓</div>
      <h2 edu-card-title>{{ successMessage }}</h2>
      <p class="integration-description">Redirecting you back to settings...</p>
    </div>

    <div *ngIf="errorMessage && !isLoading" class="callback-content">
      <div class="error-icon">✗</div>
      <h2 edu-card-title>Failed to Link Zoom Account</h2>
      <p class="integration-description error-text">{{ errorMessage }}</p>
      <p class="integration-description">Redirecting you back to settings...</p>
    </div>
  </edu-card>
</div>
